import React from "react";
import {
  Icon,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
  Text,
  useDisclosure,
  useColorModeValue,
  IconButtonProps,
} from "@chakra-ui/react";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import { useTheme } from "../context/ThemeContext";
import type { IconType } from "react-icons";

interface ToggleColorModeButtonProps {
  iconButtonProps?: Omit<IconButtonProps, "aria-label">;
  width?: string | number;
  height?: string | number;
}

export const ToggleColorModeButton: React.FC<ToggleColorModeButtonProps> = ({
  iconButtonProps,
  width,
  height,
}) => {
  const { isDarkMode, toggleTheme } = useTheme();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const label = isDarkMode ? "Switch to light mode" : "Switch to dark mode";
  const IconComponent: IconType = isDarkMode ? MdLightMode : MdDarkMode;
  const popoverBg = useColorModeValue("white", "navy.900");

  const handleToggle = (): void => {
    toggleTheme();
  };

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="auto">
      <PopoverTrigger>
        <IconButton
          isRound
          aria-label={label}
          icon={<Icon as={IconComponent as any} w={width} h={height} />}
          onClick={handleToggle}
          onMouseEnter={onOpen}
          onMouseLeave={onClose}
          {...(iconButtonProps as any)}
        />
      </PopoverTrigger>
      <PopoverContent
        bg={popoverBg}
        borderRadius="md"
        boxShadow="xl"
        p="12px"
        animation="ease-in-out"
        w={"auto"}
        minWidth="max-content"
      >
        <PopoverArrow />
        <Text>{label}</Text>
      </PopoverContent>
    </Popover>
  );
};
